export default __webpack_public_path__ + "static/media/phone.79b38e2a.svg";